/**
 * @fileoverview PATCH handler for the "/product_alerts/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { productAlertsIdCacheKeys } from "./constants";
import type { PatchProductAlertProps } from "./types";

// Pages that read the alert by id must see a status change as well as the list.
export const patchProductAlert = reactQueryMutationAdapter(
  productAlertsIdCacheKeys,
  ({ id, status }: PatchProductAlertProps) => {
    return fetch(`/product_alerts/${id}`, "PATCH", { status }, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
